import React, {useState} from 'react'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';

const rows = [
  { userId: 1,  userName: 'plasmatech8',  holding: Math.random() * 80, status: 'Owner' },
  { userId: 2,  userName: 'blazar',       holding: Math.random() * 80, status: 'Collaborator' },
  { userId: 3,  userName: 'Mr360',        holding: Math.random() * 80, status: 'User' },
  { userId: 4,  userName: 'A',            holding: Math.random() * 80, status: 'User' },
  { userId: 5,  userName: 'B',            holding: Math.random() * 80, status: 'User' },
  { userId: 6,  userName: 'C',            holding: Math.random() * 80, status: 'User' },
  { userId: 7,  userName: 'D',            holding: Math.random() * 80, status: 'User' },
  { userId: 8,  userName: 'E',            holding: Math.random() * 80, status: 'User' },
  { userId: 9,  userName: 'F',            holding: Math.random() * 80, status: 'User' },
  { userId: 10, userName: 'G',            holding: Math.random() * 80, status: 'User' },
  { userId: 11, userName: 'H',            holding: Math.random() * 80, status: 'User' },
  { userId: 12, userName: 'I',            holding: Math.random() * 80, status: 'User' },
  { userId: 99, userName: 'J',            holding: Math.random() * 80, status: 'User' },
  { userId: 13, userName: 'K',            holding: Math.random() * 80, status: 'User' },
  { userId: 14, userName: 'L',            holding: Math.random() * 80, status: 'User' },
  { userId: 15, userName: 'M',            holding: Math.random() * 80, status: 'User' },
  { userId: 46, userName: 'N',            holding: Math.random() * 80, status: 'User' },
]

function ShareholdersTable() {

  const [orderBy, setOrderBy] = useState(null)
  const [orderDirection, setOrderDirection] = useState('asc')
  const [sortedRows, setSortedRows] = useState(rows)

  const handleChangeOrdering = (newOrderBy) => {
    const newOrderDirection = (
      newOrderBy === orderBy
      ? (orderDirection === 'asc' ? 'desc' : 'asc')
      : 'asc'
    )
    setOrderBy(newOrderBy)
    setOrderDirection(newOrderDirection)
    let newRows;
    switch (newOrderBy) {
      case 'userName':
        newRows = rows.sort((a, b) => a.userName < b.userName)
        break;
      case 'holding':
        newRows = rows.sort((a, b) => a.holding < b.holding)
        break;
      case 'status':
        newRows = rows.sort((a, b) => a.status < b.status)
        break;
      default:
        break;
    }
    setSortedRows(newOrderDirection === 'asc' ? newRows : newRows.reverse())
  }

  return (
    <div>
      <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align='left'>
              <TableSortLabel
                active={orderBy === 'userName'}
                direction={orderDirection}
                onClick={() => handleChangeOrdering('userName')}
              >
                Username
              </TableSortLabel>
            </TableCell>
            <TableCell align='left'>
              <TableSortLabel
                active={orderBy === 'holding'}
                direction={orderDirection}
                onClick={() => handleChangeOrdering('holding')}
              >
                Holding
              </TableSortLabel>
            </TableCell>
            <TableCell align='left'>
              <TableSortLabel
                active={orderBy === 'status'}
                direction={orderDirection}
                onClick={() => handleChangeOrdering('status')}
              >
                Status
              </TableSortLabel>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            sortedRows.map(row => (
                          <TableRow key={row.userId}>
                            <TableCell>{row.userName}</TableCell>
                            <TableCell>{row.holding}</TableCell>
                            <TableCell>{row.status}</TableCell>
                          </TableRow>
                      )
                    )
          }
        </TableBody>
        </Table>

      </TableContainer>

    </div>
  )
}

export default ShareholdersTable
